import { Box, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { DatePivotParams } from "../../../entities/date_pivot_params";

interface IncludeAtomicPurchasePlanProps<T extends DatePivotParams> {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const IncludeAtomicPurchasePlan = <T extends DatePivotParams>({
  value,
  onChange,
  disabled = false,
}: IncludeAtomicPurchasePlanProps<T>) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <Box sx={{ mr: 2 }}>
      <Box sx={{ fontSize: 11, mb: 0.1 }}>Include Atomic Purchase Plan</Box>
      <Select
        disabled={disabled}
        variant="standard"
        size="small"
        value={value}
        onChange={handleChange}
      >
        <MenuItem value="yes">yes</MenuItem>
        <MenuItem value="no">no</MenuItem>
      </Select>
    </Box>
  );
};
